var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.class_name,attrs:{"type":"button","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"})])
}
var staticRenderFns = []

export { render, staticRenderFns }